import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { centralActions } from "../../../store";
import { StatsGuide } from "./Guide";
import { getCurrentUser } from "@neumetric/blueprint-lib/store";
import { DepartmentVsSeverity } from "./DepartmentVsSeverity";
import { StatusVsSeverity } from "./StatusVsSeverity";
import { DepartmentVsStatus } from "./DepartmentVsStatus";
import { RiskByDecisionAndStatus } from "./RiskByDecisionAndStatus";
import "./styles.scss";

export const MitigatorStats = (props) => {
  const { mode } = props;
  const user = useSelector(getCurrentUser);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(centralActions.fetchMitigatorDashboardData());
  }, [dispatch]);

  return (
    <>
      {mode === "full" && (
        <div
          className="stats-screen o-auto h-100 mt-20 mb-80 pl-20 pr-20"
          style={{ overflowY: "auto", overflowX: "auto" }}
        >
          <div className="mt-12">
            {" "}
            <StatsGuide />
          </div>
          <div className="mt-12">
            {" "}
            <RiskByDecisionAndStatus user={user} />
          </div>
          <div className="mt-30">
            {" "}
            <DepartmentVsSeverity user={user} />
          </div>
          <div className="mt-30">
            {" "}
            <StatusVsSeverity user={user} />
          </div>
          <div className="mt-30 mb-20">
            {" "}
            <DepartmentVsStatus user={user} />
          </div>
        </div>
      )}
      {mode === "fusion" && <RiskByDecisionAndStatus user={user} mode={mode} />}
    </>
  );
};
